import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_PII_CUSTOM_ENTITIES_FEATURE_ENABLED is set to
// "true" on the server. Reads from the public /app-config endpoint so the
// flag is available pre-auth (the Chat Settings page hides the PII custom
// entities section, and the server mirrors the same guard for direct API
// callers while the masking pipeline skips custom recognizers entirely).
export const usePiiCustomEntitiesFeatureEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isPiiCustomEntitiesFeatureEnabled ?? false;
};
